<template>
  <iframe :src="url" class="pdfcon" frameborder="0" v-if="url"></iframe>
</template>

<script>
import { updateHead } from '@/utils'
import { interfacePrefix } from '@/config'

export default {
  data() {
    return {
      url: '',
    }
  },
  methods: {
    getSrc() {
      const { orderId, templateId } = this.$route.query
      if (orderId && templateId) {
        this.url =
          `${interfacePrefix
          }/contract/preview?orderId=${
            orderId
          }&templateId=${
            templateId}`
      } else if (templateId) {
        this.url =
          `${interfacePrefix
          }/contract/template/effectPreview?` +
          `id=${
            templateId}`
      } else {
        this.$message.error('缺少参数')
        this.$router.push('/404')
      }
    },
  },
  created() {
    updateHead && updateHead(this.$store)
    this.getSrc()
  },
}
</script>

<style lang="scss" scoped>
.pdfcon {
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>

